import React from 'react';
import { AcvtSupportedLanguages } from '../../../types/acvt';
import { Text } from '../../../utils/text';
import { AcvtTopTabs } from '../top-tabs';
import { Card } from 'antd';

export const AcvtCanvas = (props: {
    children?: React.ReactNode;
    changeLang: (lang: AcvtSupportedLanguages) => void;
}) => {
    return (
        <Card>
            <AcvtTopTabs
                tabType="card"
                tabChangeLanguage={props.changeLang}
                tabsArray={[
                    {
                        name: Text.ACVT.canvas.tabLangEn,
                        key: 'en',
                        children: <div>{props.children}</div>,
                    },
                    {
                        name: Text.ACVT.canvas.tabLangFr,
                        key: 'fr',
                        children: <div>{props.children}</div>,
                    },
                ]}
            />
        </Card>
    );
};
